module.exports = __webpack_public_path__ + "img/mexico.ee70e6a6.svg";